function getBase64FileSize(base64String: string): number {
    // 去掉 data URL 前缀（如果有的话）
    const base64 = base64String.split(',')[1] || base64String;

    // 计算原始字节大小
    const padding = (base64.match(/=+$/) || [''])[0].length;
    const sizeInBytes = (base64.length * 3) / 4 - padding;

    return sizeInBytes;
}

export function statUpload(
    fileData: string | File,
    type: string,
    extra: {
        startTime: number;
        success: boolean;
        partSize?: number;
        maxConcurrent?: number;
    },
) {
    if (!window?.mtstat?.track) return;
    const { startTime, success, partSize, maxConcurrent } = extra;

    let fileSize = 0;
    if (typeof fileData === 'string') {
        fileSize = getBase64FileSize(fileData);
    } else {
        fileSize = fileData.size;
    }

    window.mtstat.track('upload_file_to_obs', {
        type,
        file_size: (fileSize / 1024 / 1024).toFixed(2),
        duraction: ((performance.now() - startTime) / 1000).toFixed(2),
        success: success ? 1 : 0,
        file_type: fileData instanceof File ? fileData.type : 'base64',
        part_size: partSize || 0,
        max_concurrent: maxConcurrent || 0,
    });
}
